import { ArticleDataObject } from "@app/types/Cue";
import BasicCard from "@components/ArticleCard/BasicCard";
import { CardVariations } from "@components/ArticleCard/types";
import {
  Options,
  Splide,
  SplideSlide,
  SplideTrack,
} from "@greglaisph/react-splide";
import cx from "classnames";
import { truncate } from "lodash-es";

import "@greglaisph/react-splide/css";

export interface PodcastsTopFeaturedCarouselProps {
  data: ArticleDataObject[];
}

export default function PodcastsTopFeaturedCarousel({
  data,
}: PodcastsTopFeaturedCarouselProps): React.ReactElement {
  const cardVariant: CardVariations = {
    image: {
      width: "w-full lg:w-7/12 xl:w-8/12",
      position: "left",
      filters: [
        { breakpoint: "(min-width: 992px)", w: 900, h: 600, dpr: 1, f: "webp" },
        { breakpoint: "(min-width: 768px)", w: 696, h: 464, dpr: 1, f: "webp" },
        { w: 401, h: 267, dpr: 1, f: "webp" },
      ],
    },
    content: {
      width: "w-full lg:w-5/12 xl:w-4/12",
      extraClass: cx(
        "flex-grow-0 items-center justify-center bg-gray-850 p-4 pb-8 text-white lg:items-start lg:justify-start"
      ),
    },
    title: {
      size: "text-xl xl:text-3xl",
      color: "text-white",
      extraClass: "text-center lg:text-left font-lct",
    },
    kicker: {
      color: "text-gray-515",
      extraClass: "uppercase",
    },
  };
  const options: Options = {
    perPage: 1,
    perMove: 1,
    pagination: true,
    arrows: false,
    snap: true,
    type: "loop",
    autoHeight: true,
  };

  return (
    <div
      className="relative"
      data-testid="podcasts-top-feature-carousel-component"
    >
      <Splide options={options} hasTrack={false}>
        <SplideTrack>
          {data.map(
            ({ id, title, media, kicker, sections, paywall, blurb, slug }) => {
              return (
                <SplideSlide className="w-full bg-gray-850" key={id}>
                  <BasicCard
                    id={id}
                    title={title}
                    slug={slug}
                    paywall={paywall?.contentAccess === "1"}
                    kicker={kicker?.fields?.at(0)?.value}
                    blurb={truncate(blurb, { length: 60 })}
                    media={media}
                    variations={cardVariant}
                    defaultImage={{
                      directoryName: sections?.at(0)?.uniqueName || "",
                    }}
                    rootClassName="h-full flex-col lg:flex-row"
                  />
                </SplideSlide>
              );
            }
          )}
        </SplideTrack>

        <ul
          className={cx(
            "splide__pagination podcast-featured-carousel",
            "lg:left-[unset] lg:right-0 lg:w-5/12",
            "xl:w-4/12"
          )}
        ></ul>
      </Splide>
    </div>
  );
}
